var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "user-details-grid" }, [
    _c("div", { staticClass: "header-container" }, [
      _c(
        "div",
        { staticClass: "system-type-filter" },
        [
          _c("SingleFilter", {
            attrs: {
              columns: _vm.filterColumns,
              filter: _vm.filter,
              isStatic: "",
            },
            on: {
              "filter-selected": _vm.handleFilterChange,
              "filter-emptied": _vm.handleFilterEmpty,
              "static-filter-cleared": _vm.handleFilterEmpty,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "date-time-container" }, [
        _c("span", { staticClass: "timezone-text" }, [
          _vm._v(_vm._s(_vm.timezoneText)),
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "date-selection-wrapper" },
          [
            _c("date-selection", {
              attrs: {
                "min-date": _vm.minDate,
                "max-date": _vm.maxDate,
                "date-text": _vm.dateText,
                value: _vm.dateValue,
              },
              on: { "range-selected": _vm.handleDateRangeUpdate },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "user-details-grid-panels-wrapper" }, [
      _c(
        "div",
        { staticClass: "user-details-grid-panel half-width" },
        [
          _c(
            "grid-panel",
            {
              staticClass: "user-details-meetings-panel",
              attrs: {
                panelHeader: _vm.meetingsPanelHeaderTemplate,
                loading: _vm.loading,
              },
            },
            [
              _c("user-details-trend-chart", {
                attrs: {
                  categories: _vm.meetingsCategories,
                  chartSeries: _vm.meetingsChartSeries,
                  clickCallback: _vm.meetingsClickCallback,
                  labelClickCallback: _vm.meetingsLabelClickCallbackComputed,
                  showLegend: "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "user-details-grid-panel experience-score-panel half-width",
        },
        [
          _c(
            "grid-panel",
            {
              attrs: { panelHeader: "Experience Score", loading: _vm.loading },
            },
            [
              _c("user-details-experience-score-panel", {
                attrs: {
                  userExperienceScoreKpi: _vm.userExperienceScore.kpi,
                  userExperienceScoreTrend: _vm.userExperienceScore.trend,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "user-details-grid-panel third-width" },
        [
          _c(
            "grid-panel",
            {
              staticClass: "user-details-connection-quality-panel",
              attrs: { panelTitle: "Connection Quality", loading: _vm.loading },
            },
            [
              _c("user-details-pie-chart", {
                attrs: {
                  chartSeries: _vm.connectionQualityChartSeries,
                  clickCallback: _vm.connectionQualityClickCallback,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "user-details-grid-panel usage-history-panel full-width",
        },
        [
          _c(
            "grid-panel",
            {
              staticClass: "user-details-usage-history-panel",
              attrs: { panelHeader: "Meeting History", loading: _vm.loading },
            },
            [
              _c("user-details-usage-history-chart", {
                attrs: {
                  chartSeries: _vm.usageHistoryChartSeries,
                  clickCallback: _vm.usageHistoryClickCallback,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "user-details-grid-panel connection-speed-panel third-width",
        },
        [
          _c(
            "grid-panel",
            {
              staticClass: "user-details-connection-speed-panel",
              attrs: { loading: _vm.loading },
            },
            [
              _c("user-details-connection-speed-panel", {
                attrs: {
                  wifi: _vm.connectionSpeed.wifi,
                  ethernet: _vm.connectionSpeed.ethernet,
                  cell: _vm.connectionSpeed.cell,
                  vpn: _vm.connectionSpeed.vpn,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "user-details-grid-panel half-width" },
        [
          _c(
            "grid-panel",
            {
              staticClass: "user-details-meeting-peripherals-panel",
              attrs: {
                panelHeader: "Meeting Peripherals",
                loading: _vm.loading,
              },
            },
            [
              _c("user-details-trend-chart", {
                attrs: {
                  categories: _vm.meetingPeripheralsCategories,
                  chartSeries: _vm.meetingPeripheralsChartSeries,
                  clickCallback: _vm.meetingPeripheralsClickCallback,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "user-details-grid-panel half-width" },
        [
          _c(
            "grid-panel",
            {
              staticClass: "user-details-meeting-devices-panel",
              attrs: { panelHeader: "Meeting Devices", loading: _vm.loading },
            },
            [
              _c("user-details-trend-chart", {
                attrs: {
                  categories: _vm.meetingDevicesCategories,
                  chartSeries: _vm.meetingDevicesChartSeries,
                  clickCallback: _vm.meetingDevicesClickCallback,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "user-details-grid-panel third-width" },
        [
          _c(
            "grid-panel",
            {
              staticClass: "user-details-network-type-panel",
              attrs: { panelTitle: "Network Type", loading: _vm.loading },
            },
            [
              _c("user-details-pie-chart", {
                attrs: {
                  chartSeries: _vm.networkTypeChartSeries,
                  clickCallback: _vm.networkTypeClickCallback,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }